<template>
  <div class="border-b border-royal-blue-20 bg-white">
    <div class="container">
      <div class="py-8">
        <component
          :is="isMainHeading ? 'h1' : 'p'"
          id="appTitle"
          class="font-bitter text-3xl font-bold mb-4"
        >
          Chemical Science
        </component>
        <slot name="pageGuidance">
        </slot>
        <SubmissionProgress />
      </div>
    </div>
  </div>
  <template v-if="layout === 'two-column'">
    <div :class="bgClass">
      <div class="container pt-16 pb-32">
        <div class="flex flex-col lg:flex-row w-full gap-6">
          <div class="w-full lg:w-2/3">
            <slot>
            </slot>
          </div>
        </div>
      </div>
    </div>
    <div class="container">
      <SupportInfo />
    </div>
  </template>

  <template v-else>
    <div :class="[bgClass, 'flex-1']">
      <div class="container pt-16 pb-32">
        <slot>
        </slot>
      </div>
    </div>
  </template>
</template>

<script setup lang="ts">
import SupportInfo from '@/components/common/SupportInfo.vue'
import SubmissionProgress from '@/components/progress/SubmissionProgress.vue'

defineProps({
  bgClass: {
    type: String,
    default: '',
  },
  layout: {
    type: String,
    default: 'default',
    validator: (value: string) => ['default', 'two-column'].includes(value),
  },
  isMainHeading: {
    type: Boolean,
    default: false,
  },
})
</script>
